module.exports = __webpack_public_path__ + "img/40_38_078_310.70ed62cb.jpg";